// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","link":"Footer_link__c5ir1"};